export default __webpack_public_path__ + "static/media/ic-timer-x.28bb1146.svg";